module.exports = __webpack_public_path__ + "img/ИФ-1(А)-049.a5198517.png";